module.exports = __webpack_public_path__ + "img/envelopamento2.78509d87.jpg";